import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import GuideLayout from './GuideLayout';
import plaquePreview from '../../../img/home-tabliczka-zlota.webp';

// Poradnik pod frazy wyszukiwane przez zakłady pogrzebowe: „jak zrobić tabliczkę na krzyż”,
// „tabliczki nagrobne sublimacja”, „druk tabliczek nagrobnych”, „maszyna do tabliczek nagrobnych”.
// Porównuje metody wykonania i poleca sublimację jako najlepszy wybór dla większości zakładów.

const METHODS = [
    {
        title: 'Sublimacja',
        text: 'Wydruk atramentem sublimacyjnym na papierze transferowym, przeniesiony prasą termiczną na blachę aluminiową z powłoką. Pełny kolor ze zdjęciem, gotowe w kilka minut.',
        recommended: true,
    },
    {
        title: 'Druk UV',
        text: 'Drukarka UV nanosi farbę bezpośrednio na plexi, dibond lub aluminium. Świetny efekt, ale sprzęt jest drogi - zakłady zwykle zlecają taki druk na zewnątrz.',
    },
    {
        title: 'Grawer laserowy',
        text: 'Laser wypala napis w laminacie grawerskim, anodowanym aluminium lub mosiądzu. Elegancki i trwały, ale zazwyczaj bez kolorowego zdjęcia.',
    },
    {
        title: 'Folia samoprzylepna',
        text: 'Wydruk na folii naklejony na podkład i zabezpieczony laminatem. Tani start, ale folia z czasem płowieje i może odklejać się na brzegach.',
    },
    {
        title: 'Naklejane litery',
        text: 'Pojedyncze litery i cyfry z folii przyklejane ręcznie, jedna po drugiej, na gotową tabliczkę. Nie wymaga sprzętu, ale jest pracochłonne, trudno o równe odstępy, a litery z czasem odklejają się i giną.',
    },
    {
        title: 'Papier i laminowanie',
        text: 'Zwykły wydruk zalaminowany i włożony w ramkę. Najszybsze rozwiązanie awaryjne, ale wilgoć i słońce szybko go niszczą.',
    },
    {
        title: 'Odlew i trawienie',
        text: 'Tabliczki z mosiądzu lub brązu wykonywane przez wyspecjalizowane pracownie. Najtrwalsze i najdroższe - to raczej tabliczka na pomnik niż na krzyż.',
    },
];

const COMPARE_COLUMNS = ['Sublimacja', 'Druk UV', 'Grawer', 'Folia', 'Naklejane litery', 'Papier'];

const COMPARE_ROWS = [
    { label: 'Kolorowe zdjęcie zmarłego', values: ['Tak, fotograficzna jakość', 'Tak', 'Zwykle nie', 'Tak', 'Nie', 'Tak'] },
    { label: 'Odporność na deszcz i słońce', values: ['Wysoka', 'Wysoka', 'Bardzo wysoka', 'Średnia', 'Niska - litery się odklejają', 'Niska'] },
    { label: 'Odporność na zarysowania', values: ['Wysoka - barwnik jest w powłoce', 'Średnia - farba na powierzchni', 'Wysoka', 'Niska', 'Niska', 'Niska'] },
    { label: 'Koszt sprzętu', values: ['Niski', 'Bardzo wysoki', 'Średni-wysoki', 'Niski', 'Brak', 'Bardzo niski'] },
    { label: 'Koszt jednej tabliczki', values: ['Niski', 'Średni', 'Średni', 'Niski', 'Niski', 'Bardzo niski'] },
    { label: 'Wykonanie od ręki w zakładzie', values: ['Tak, kilka minut', 'Rzadko', 'Tak', 'Tak', 'Tak, ale długo - litera po literze', 'Tak'] },
    { label: 'Wygląd', values: ['Profesjonalny, metaliczny', 'Profesjonalny', 'Elegancki', 'Amatorski', 'Często nierówne odstępy', 'Tymczasowy'] },
];

const WHY_SUBLIMATION = [
    { title: 'Zdjęcie jak z fotografii', text: 'Sublimacja oddaje płynne przejścia tonów, dlatego portret zmarłego wygląda naturalnie - także w czerni i bieli.' },
    { title: 'Barwnik wewnątrz powłoki', text: 'Pod wpływem temperatury atrament przechodzi w gaz i wnika w powłokę blachy. Nadruk nie leży na powierzchni, więc nie łuszczy się i trudno go zarysować.' },
    { title: 'Tani start, tania tabliczka', text: 'Wystarczy drukarka sublimacyjna, prasa termiczna i blachy. To ułamek ceny drukarki UV czy lasera fiber, a koszt jednej tabliczki to głównie blacha i papier.' },
    { title: 'Gotowe przed pogrzebem', text: 'Wydruk i prasowanie zajmują kilka minut. Tabliczkę zrobisz w zakładzie tego samego dnia, bez czekania na zewnętrzną pracownię.' },
    { title: 'Złota, srebrna lub biała', text: 'Blachy sublimacyjne występują w wielu wykończeniach - złotym, srebrnym, białym, szczotkowanym. Jeden sprzęt, wiele wzorów.' },
    { title: 'Krzyż, znicz, trumna, urna', text: 'Na tym samym sprzęcie wykonasz tabliczkę na krzyż, na znicz, na trumnę i na urnę - zmienia się tylko rozmiar blachy.' },
];

const STEPS = [
    {
        title: 'Przygotuj projekt tabliczki',
        text: (
            <>
                Wpisz dane zmarłego, wybierz wzór i pobierz plik do druku. W Nekrodruku tabliczkę zrobisz z tych samych
                danych co nekrolog - zobacz, <Link to='/co-to-nekrolog'>co powinien zawierać nekrolog</Link>.
            </>
        ),
    },
    {
        title: 'Wydrukuj na papierze transferowym',
        text: 'Drukarką z atramentem sublimacyjnym, w lustrzanym odbiciu (ustawisz je w sterowniku drukarki). Wydruk wygląda blado - kolory pojawią się dopiero po prasowaniu.',
    },
    {
        title: 'Przyłóż papier do blachy',
        text: 'Ułóż wydruk na blasze sublimacyjnej nadrukiem do powłoki i przymocuj taśmą termiczną, żeby nie przesunął się w prasie.',
    },
    {
        title: 'Zaprasuj w prasie termicznej',
        text: 'Temperaturę, czas i docisk ustaw według zaleceń producenta blach - zwykle około 200°C przez kilkadziesiąt sekund.',
    },
    {
        title: 'Zdejmij papier i zamontuj',
        text: 'Ostrożnie zdejmij gorący papier, poczekaj, aż blacha ostygnie, i przymocuj tabliczkę do krzyża, urny lub trumny.',
    },
];

const TIPS = [
    { title: 'Wybieraj blachy do użytku zewnętrznego', text: 'Tabliczka na krzyż stoi na cmentarzu miesiącami. Blachy przeznaczone na zewnątrz lepiej znoszą słońce i deszcz.' },
    { title: 'Pamiętaj o lustrzanym odbiciu', text: 'Najczęstszy błąd początkujących. Jedna wydrukowana odwrotnie tabliczka to zmarnowana blacha.' },
    { title: 'Na złotej blasze nie ma białego', text: 'Sublimacja nie drukuje bieli - białe miejsca pokazują kolor blachy. Na złotej lub srebrnej blasze projektuj ciemny tekst.' },
    { title: 'Sprawdź dane przed prasowaniem', text: 'Po zaprasowaniu nie poprawisz literówki. Przeczytaj imię, nazwisko i daty z rodziną jeszcze na etapie projektu.' },
];

const FAQ = [
    {
        question: 'Jaka metoda wykonania tabliczek nagrobnych jest najlepsza?',
        answer: 'Dla większości zakładów pogrzebowych - sublimacja. Daje pełny kolor ze zdjęciem, jest odporna na warunki atmosferyczne i zarysowania, a sprzęt i pojedyncza tabliczka są tanie. Grawer i odlew sprawdzą się przy tabliczkach premium lub docelowych na pomnik.',
    },
    {
        question: 'Jaki sprzęt jest potrzebny do sublimacji tabliczek?',
        answer: 'Drukarka z atramentem sublimacyjnym, papier transferowy, prasa termiczna (płaska) i blachy aluminiowe z powłoką sublimacyjną w potrzebnych rozmiarach. Do tego taśma termiczna do mocowania wydruku.',
    },
    {
        question: 'Czy tabliczka sublimacyjna jest odporna na deszcz i słońce?',
        answer: 'Tak - barwnik wnika w powłokę blachy, więc nadruk nie zmywa się i nie łuszczy. Przy tabliczkach na cmentarz wybieraj blachy przeznaczone do użytku zewnętrznego.',
    },
    {
        question: 'Ile trwa wykonanie tabliczki metodą sublimacji?',
        answer: 'Sam wydruk i prasowanie zajmują kilka minut. Z gotowym projektem z Nekrodruku całą tabliczkę zrobisz w zakładzie w kilkanaście minut.',
    },
    {
        question: 'Czy z Nekrodruku mogę drukować tabliczki inną metodą?',
        answer: 'Tak. Pobierasz projekt jako PDF lub JPG, więc możesz go wydrukować sublimacyjnie, przekazać do druku UV albo wysłać do pracowni. Projekt nie zależy od metody wykonania.',
    },
];

export default function TabliczkiNagrobne() {
    return (
        <GuideLayout
            path='/jak-zrobic-tabliczke-nagrobna'
            title='Jak zrobić tabliczkę nagrobną? Sublimacja, druk UV, grawer - porównanie | Nekrodruk.pl'
            description='Jak wykonać tabliczkę na krzyż, urnę lub trumnę? Porównanie metod dla zakładów pogrzebowych: sublimacja, druk UV, grawer laserowy, folia, naklejane litery i laminowanie. Dlaczego sublimacja to najlepszy wybór i jak zrobić tabliczkę krok po kroku.'
            keywords='jak zrobić tabliczkę na krzyż, tabliczki nagrobne sublimacja, sublimacja tabliczek, druk tabliczek nagrobnych, tabliczka na krzyż ze zdjęciem, maszyna do tabliczek nagrobnych, tabliczka na urnę, tabliczka na trumnę, blacha sublimacyjna'
            heading={<>Jak zrobić tabliczkę nagrobną?<em> Porównanie metod dla zakładów pogrzebowych</em></>}
            lead='Sublimacja, druk UV, grawer, folia, naklejane litery czy zwykły wydruk? Porównujemy sposoby wykonania tabliczek na krzyż, znicz, trumnę i urnę - i podpowiadamy, dlaczego większość zakładów najlepiej wychodzi na sublimacji.'
            actions={
                <>
                    <Link to='/register' className='guide_btn guide_btn--light'>
                        Załóż konto
                    </Link>
                    <HashLink smooth to='/jak-zrobic-tabliczke-nagrobna#porownanie' className='guide_btn guide_btn--ghost'>
                        Zobacz porównanie
                    </HashLink>
                </>
            }
            faq={FAQ}
        >
            <section className='guide_section'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Metody wykonania</span>
                    <h2 className='guide_title'>Sposoby wykonania tabliczek nagrobnych</h2>
                    <p className='guide_lead'>
                        Tabliczka na krzyż stoi zwykle od kilku miesięcy do roku - aż do postawienia pomnika. Powinna więc
                        wyglądać godnie, przetrwać deszcz i słońce, a jednocześnie być gotowa przed pogrzebem i nie kosztować
                        majątku. Oto najpopularniejsze metody.
                    </p>
                    <div className='guide_cards'>
                        {METHODS.map((method) => (
                            <article key={method.title} className={`guide_card ${method.recommended ? 'guide_card--recommended' : ''}`}>
                                {method.recommended ? <span className='guide_badge'>Polecamy</span> : null}
                                <h3>{method.title}</h3>
                                <p>{method.text}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className='guide_section guide_section--soft' id='porownanie'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Porównanie</span>
                    <h2 className='guide_title'>Która metoda wypada najlepiej?</h2>
                    <div className='guide_compareWrap'>
                        <table className='guide_compare'>
                            <thead>
                                <tr>
                                    <th scope='col'>Cecha</th>
                                    {COMPARE_COLUMNS.map((column, index) => (
                                        <th key={column} scope='col' className={index === 0 ? 'guide_compareBest' : ''}>
                                            {column}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {COMPARE_ROWS.map((row) => (
                                    <tr key={row.label}>
                                        <th scope='row'>{row.label}</th>
                                        {row.values.map((value, index) => (
                                            <td key={COMPARE_COLUMNS[index]} className={index === 0 ? 'guide_compareBest' : ''}>
                                                {value}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <p className='guide_note'>
                        Grawer i odlew są najtrwalsze, ale zwykle bez kolorowego zdjęcia i drożej - lepiej sprawdzają się
                        przy tabliczkach docelowych na pomnik. Przy tabliczkach na krzyż, znicz, trumnę i urnę sublimacja
                        daje najlepszy stosunek jakości, trwałości i ceny.
                    </p>
                </div>
            </section>

            <section className='guide_section'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Dlaczego sublimacja</span>
                    <h2 className='guide_title'>Sublimacja - najlepszy wybór dla zakładu pogrzebowego</h2>
                    <figure className='guide_screenshot'>
                        <img
                            src={plaquePreview}
                            alt='Złota tabliczka nagrobna na krzyż ze zdjęciem zmarłego, imieniem, nazwiskiem i datami'
                            width='792'
                            height='452'
                            loading='lazy'
                        />
                        <figcaption>Tabliczka na krzyż zaprojektowana w Nekrodruku - wzór na złotą blachę sublimacyjną</figcaption>
                    </figure>
                    <div className='guide_cards'>
                        {WHY_SUBLIMATION.map((item) => (
                            <article key={item.title} className='guide_card'>
                                <h3>{item.title}</h3>
                                <p>{item.text}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className='guide_section guide_section--soft'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Krok po kroku</span>
                    <h2 className='guide_title'>Jak zrobić tabliczkę na krzyż metodą sublimacji?</h2>
                    <ol className='guide_steps guide_steps--wide'>
                        {STEPS.map((step) => (
                            <li key={step.title}>
                                <strong>{step.title}</strong>
                                <span>{step.text}</span>
                            </li>
                        ))}
                    </ol>
                </div>
            </section>

            <section className='guide_section'>
                <div className='guide_inner'>
                    <span className='guide_kicker'>Wskazówki</span>
                    <h2 className='guide_title'>Jak uniknąć błędów przy sublimacji tabliczek</h2>
                    <ul className='guide_checklist'>
                        {TIPS.map((tip) => (
                            <li key={tip.title}>
                                <strong>{tip.title}</strong>
                                <span>{tip.text}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section className='guide_section guide_section--soft'>
                <div className='guide_inner'>
                    <div className='guide_callout'>
                        <div>
                            <h2>
                                Projekt tabliczki w kilka minut<em> - gotowy do sublimacji</em>
                            </h2>
                            <p>
                                Wpisz dane zmarłego raz, a Nekrodruk przygotuje tabliczkę na krzyż, znicz, trumnę i urnę oraz
                                nekrolog i szarfę. Masz pytania o sprzęt do sublimacji? Napisz - podpowiemy.
                            </p>
                        </div>
                        <div className='guide_actions'>
                            <Link to='/register' className='guide_btn guide_btn--light'>
                                Załóż konto
                            </Link>
                            <HashLink smooth to='/#Contact' className='guide_btn guide_btn--ghost'>
                                Napisz do nas
                            </HashLink>
                        </div>
                    </div>
                </div>
            </section>
        </GuideLayout>
    );
}
